import axios from "axios";

/** What the backend's `ErrorResponse` (`{ serviceId, errorCode, errorValues, message }`) tells us about a failed call. */
export interface ApiError {
  status: number | undefined;
  errorCode: number | undefined;
  /** `errorValues.reason`, the backend's explanation for validation errors. */
  reason: string | undefined;
}

export const getApiError = (error: unknown): ApiError => {
  const response = axios.isAxiosError(error) ? error.response : undefined;
  const body = response?.data;
  const errorCode = body && typeof body === "object" ? Number(body.errorCode) : NaN;
  const reason = body && typeof body === "object" ? body.errorValues?.reason : undefined;

  return {
    status: response?.status,
    errorCode: Number.isNaN(errorCode) ? undefined : errorCode,
    reason: typeof reason === "string" && reason ? reason : undefined,
  };
};
